import { lazy } from 'react';
import { React, Suspense } from 'libs/react';
import './LazyFormRichTextInput.scss';
/**
 * @const Editor
 * @hidden
 */
const Editor = lazy(() => import('components/form/FormRichTextInput').then((m) => ({
    default: m.FormRichTextInput
})));
/**
 * Rich text field loaded on first render: Quill and its table module stay out
 * of the bundle of the pages that never show one (store, sales forms). Same
 * props as the field itself.
 *
 * @component FormRichTextInput
 * @since 1.0.0
 */
export function FormRichTextInput(props) {
    return (React.createElement(Suspense, { fallback: React.createElement("div", { className: "form-rich-text-input-loading" }) },
        React.createElement(Editor, Object.assign({}, props))));
}
